import ErrorBoundary, { ErrorBoundaryProps } from "@pathwright/ux/src/components/error/ErrorBoundary"
import React from "react"

// Omit 'schoolName' from the props since we provide it internally
type SchoolErrorBoundaryProps = Omit<ErrorBoundaryProps, 'schoolName'>

const SchoolErrorBoundary: React.FC<SchoolErrorBoundaryProps> = ({
  children,
  logToSentry,
  renderError,
  className,
  catchLoadingChunkFailures,
  ...props
}) => {
  // Access name property safely, falling back to undefined if it doesn't exist
  const schoolName = (window.school as any)?.name

  return (
    <ErrorBoundary
      schoolName={schoolName}
      logToSentry={logToSentry}
      renderError={renderError}
      className={className}
      catchLoadingChunkFailures={catchLoadingChunkFailures}
      {...props}
    >
      {children}
    </ErrorBoundary>
  )
}

export default SchoolErrorBoundary
